import script from "./CodecValidator.vue?vue&type=script&setup=true&lang=ts"
export * from "./CodecValidator.vue?vue&type=script&setup=true&lang=ts"

import "./CodecValidator.vue?vue&type=style&index=0&id=6e78fe71&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e78fe71"]])

export default __exports__